class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.closeTimeout = null;

    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.clearCloseTimeout = this.clearCloseTimeout.bind(this);
    this.onSummaryClick = this.onSummaryClick.bind(this);

    if (this.summary) {
      this.summary.addEventListener('mouseenter', this.onMouseEnter);
      this.summary.addEventListener('focus', this.onMouseEnter);
      this.summary.addEventListener('click', this.onSummaryClick);
    }

    this.mainDetailsToggle.addEventListener('mouseenter', this.clearCloseTimeout);
    this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  shouldUseHoverInteraction() {
    return window.matchMedia('(min-width: 1100px) and (hover: hover) and (pointer: fine)').matches;
  }

  onSummaryClick(event) {
    if (!this.shouldUseHoverInteraction()) return;

    const menuUrl = this.summary?.getAttribute('data-menu-url');
    if (!menuUrl) return;

    // Desktop: hover opens the mega menu; click navigates to the collection page.
    event.preventDefault();
    window.location.assign(menuUrl);
  }

  onMouseEnter() {
    if (!this.shouldUseHoverInteraction()) return;
    this.clearCloseTimeout();

    if (!this.mainDetailsToggle.open) {
      this.closeSiblingMenus();
      this.mainDetailsToggle.setAttribute('open', '');
      this.summary?.setAttribute('aria-expanded', true);
    }
  }

  onMouseLeave() {
    if (!this.shouldUseHoverInteraction()) return;
    this.clearCloseTimeout();
    this.closeTimeout = window.setTimeout(() => this.close(), 120);
  }

  clearCloseTimeout() {
    if (!this.closeTimeout) return;
    clearTimeout(this.closeTimeout);
    this.closeTimeout = null;
  }

  closeSiblingMenus() {
    if (!this.header) return;

    this.header.querySelectorAll('header-menu details[open]').forEach((menu) => {
      if (menu === this.mainDetailsToggle) return;
      menu.removeAttribute('open');
      menu.querySelector('summary')?.setAttribute('aria-expanded', false);
    });
  }
}

customElements.define('header-menu', HeaderMenu);
